import React, { useContext, useId, useRef } from 'react';

import { number2kanji } from '@geolonia/japanese-numeral';

import FileLink from './FileLink';
import FormField from './FormField';
import QuillEditor from './QuillEditor';
import SettingsContext from './SettingsContext';

export default function Chapter({ index, number, chapter, totalChapters, addChapter, removeChapter, modifyChapter }) {
  if (!chapter._destroy) {
    return (
      <div id={`chapter-${number}`}>
        <input type='hidden' name={`${namePrefix(index)}[id]`} value={chapter.id || ''} />
        <input type='hidden' name={`${namePrefix(index)}[number]`} value={number} />

        <TitleField title={chapter.title} modifyChapter={modifyChapter} index={index} number={number} />
        <BodyField body={chapter.body} modifyChapter={modifyChapter} index={index} />
        <FileField newFile={chapter.new_file} savedFile={chapter.saved_file} modifyChapter={modifyChapter} index={index} />
        <NotesField notes={chapter.notes} modifyChapter={modifyChapter} index={index} />

        <div className='d-flex justify-content-center gap-3 mb-5'>
          {totalChapters >= 2 && (
            <button type='button' className='btn-del' onClick={() => removeChapter(index)}>章を削除</button>
          )}

          {totalChapters <= 29 && (
            <button type='button' className='btn-add' onClick={() => addChapter(index)}>章を追加</button>
          )}
        </div>
      </div>
    );
  } else {
    return (
      <>
        <input type='hidden' name={`${namePrefix(index)}[id]`} value={chapter.id} />
        <input type='hidden' name={`${namePrefix(index)}[_destroy]`} value='1' />
      </>
    );
  }
}

function TitleField({ title, modifyChapter, index, number }) {
  const id = useId();

  return (
    <FormField label={`第${number2kanji(number)}章`} id={id}>
      <input
        type='text'
        id={id}
        name={`${namePrefix(index)}[title]`}
        value={title || ''}
        onChange={(e) => {
          modifyChapter(index, { title: e.target.value });
        }}
      />
    </FormField>
  );
}

function BodyField({ body, modifyChapter, index }) {
  const id = useId();

  return (
    <FormField label='本文' id={id}>
      <QuillEditor
        id={id}
        name={`${namePrefix(index)}[body]`}
        value={body || ''}
        onChange={(value) => {
          modifyChapter(index, { body: value });
        }}
      />
    </FormField>
  );
}

function FileField({ newFile, savedFile, modifyChapter, index }) {
  const id                     = useId();
  const inputRef               = useRef(null);
  const { direct_uploads_url } = useContext(SettingsContext);

  return (
    <FormField label='添付ファイル' id={id}>
      <div className='col-12 col-xl-12 fileform--form__wrap'>
        <div className="col-12 col-xl-6">
          <input
            ref={inputRef}
            type='file'
            id={id}
            name={`${namePrefix(index)}[file]`}
            accept='.jpeg, .jpg, .png, .pdf, .doc, .docx, .xls, .xlsx, .xlsm'
            onChange={(e) => {
              modifyChapter(index, { new_file: e.target.files[0] });
            }}
            data-direct-upload-url={direct_uploads_url}
            className='form-control'
          />
        </div>

        {(newFile || savedFile) && (
          <div className='col-12 col-xl-6 d-flex align-items-center ps-3'>
            <div className='fileform--form__text ms-2'>
              <FileLink newFile={newFile} savedFile={savedFile} />
            </div>

            <button
              className='text-kuled fs-5 ms-1'
              onClick={() => {
                inputRef.current.value = '';
                modifyChapter(index, { new_file: null, saved_file: null });
              }}
            >&times;</button>
          </div>
        ) || (
          <input type='hidden' name={`${namePrefix(index)}[remove_file]`} value='1' />
        )}
      </div>

      <div className="mt-2 text-muted">ファイル形式は「JPEG、JPG、PNG、PDF、WORD、EXCEL」のみです。ファイルサイズは「最大10MB」です。</div>
    </FormField>
  );
}

function NotesField({ notes, modifyChapter, index }) {
  const id = useId();

  return (
    <FormField label='注釈' id={id}>
      <textarea
        id={id}
        name={`${namePrefix(index)}[notes]`}
        value={notes || ''}
        onChange={(e) => {
          modifyChapter(index, { notes: e.target.value });
        }}
        rows='5'
      ></textarea>
    </FormField>
  );
}

function namePrefix(i) {
  return `graduation_thesis[thesis_bodies_attributes][${i}]`;
}
